const dataURItoBlob = (dataURI: string) => {
  const binary = atob(dataURI.split(',')[1]);
  const binaryArray = binary.split('');

  const result = binaryArray.reduce((acc, _, i) => {
    acc.push(binary.charCodeAt(i));
    return acc;
  }, [] as number[]);

  return new Blob([new Uint8Array(result)], { type: 'image/jpg' });
};

export default dataURItoBlob;
